(() => {
  const faccoI18n = window.FaccoI18n || {};
  const faccoText = (key, fallback, vars = {}) => {
    let value = String(faccoI18n[key] || fallback || '');
    Object.entries(vars).forEach(([name, replacement]) => { value = value.replaceAll(`{{ ${name} }}`, String(replacement)); });
    return value;
  };
  const normalizeCarat = (value = '') => String(value).toLowerCase().replace(/\s+/g, '').replace('kt', '');

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'it-IT';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  };

  const readMainProduct = () => {
    const node = document.getElementById('FaccoCurrentProductJson');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_) {
      return null;
    }
  };

  const getMainVariant = () => {
    const product = readMainProduct();
    if (!product) return null;

    const picker = document.querySelector('variant-picker');
    if (!picker) return product.selected_or_first_available_variant || product.variants?.[0] || null;

    const selected = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value || '';
    });

    return product.variants?.find((variant) => {
      return variant.options?.every((option, index) => option === selected[index]);
    }) || product.selected_or_first_available_variant || product.variants?.[0] || null;
  };

  const initComposer = (composer) => {
    if (!composer || composer.dataset.facComposerReady === 'true') return;
    composer.dataset.facComposerReady = 'true';

    const mode = composer.dataset.mode;
    const drawers = Array.from(composer.querySelectorAll('[data-fac-composer-drawer]'));
    const cards = drawers.flatMap((drawer) => Array.from(drawer.querySelectorAll('[data-fac-addon]')));
    const summary = composer.querySelector('[data-fac-composer-summary]');
    const count = composer.querySelector('[data-fac-composer-count]');
    let lastOpener = null;

    const readAddon = (card) => {
      try {
        return JSON.parse(card.querySelector('[data-fac-addon-json]')?.textContent || '{}');
      } catch (_) {
        return {};
      }
    };

    const currentCarat = () => {
      const variant = getMainVariant();
      if (!variant) return '';
      const carat = variant.options?.find((value) => /(?:9|18)\s*kt/i.test(String(value)));
      return carat ? normalizeCarat(carat) : '';
    };

    const compatibleVariants = (card) => {
      const data = readAddon(card);
      const carat = currentCarat();
      const available = (data.variants || []).filter((variant) => variant.available !== false);
      // Basi senza caratura (es. cordino): vanno bene con qualsiasi charm.
      const hasCarat = (data.variants || []).some((variant) => (variant.options || []).some((option) => /(?:9|18)\s*kt/i.test(String(option))));
      if (!carat || !hasCarat) return available;
      return available.filter((variant) => {
        return variant.options?.some((option) => normalizeCarat(option) === carat);
      });
    };

    const variantLabel = (variant) => {
      const options = (variant.options || []).filter((value) => value && value !== 'Default Title');
      return options.length ? options.join(' · ') : faccoText('uniqueVariant', 'Variante unica');
    };

    const syncCard = (card) => {
      const variants = compatibleVariants(card);
      const select = card.querySelector('[data-fac-addon-variant]');
      const oldValue = String(select?.value || card.dataset.variantId || '');

      if (select) {
        select.innerHTML = '';
        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = `${variantLabel(variant)} — ${formatMoney(variant.price)}`;
          select.appendChild(option);
        });
        if (variants.some((variant) => String(variant.id) === oldValue)) select.value = oldValue;
        select.disabled = variants.length === 0;
      }

      const selectedVariant = variants.find((variant) => String(variant.id) === String(select?.value || oldValue)) || variants[0] || null;
      if (select && selectedVariant) select.value = String(selectedVariant.id);
      card.dataset.variantId = selectedVariant?.id || '';
      card.classList.toggle('is-incompatible', !selectedVariant);

      const price = card.querySelector('[data-fac-addon-price]');
      if (price && selectedVariant) price.textContent = formatMoney(selectedVariant.price);

      const button = card.querySelector('[data-fac-addon-toggle]');
      if (button) button.disabled = !selectedVariant;

      if (!selectedVariant && card.classList.contains('is-selected')) {
        card.classList.remove('is-selected');
        button?.setAttribute('aria-pressed', 'false');
        if (button) button.textContent = faccoText('add', 'AGGIUNGI');
      }
    };

    const selectedCards = () => cards.filter((card) => card.classList.contains('is-selected') && card.dataset.variantId);

    const preview = composer.querySelector('[data-fac-pairing-preview]');
    const readPins = (node) => {
      try { return JSON.parse(node?.textContent || '{}'); } catch (_) { return {}; }
    };
    const mainPins = readPins(composer.querySelector('[data-fac-main-pins]'));

    const renderPreview = (card) => {
      if (!preview) return;
      const canvas = preview.querySelector('[data-fac-pairing-canvas]');
      const fallback = preview.querySelector('[data-fac-pairing-fallback]');
      if (!card) {
        preview.hidden = true;
        return;
      }
      const data = readAddon(card);
      const variant = (data.variants || []).find((v) => String(v.id) === String(card.dataset.variantId));
      const photo = variant?.featured_image?.src || data.featured_image || card.querySelector('img')?.currentSrc || '';
      const showFallback = () => {
        if (canvas) canvas.hidden = true;
        if (fallback && photo) {
          fallback.src = photo;
          fallback.alt = data.title || '';
          fallback.hidden = false;
          preview.hidden = false;
        } else {
          preview.hidden = true;
        }
      };
      const basePin = readPins(card.querySelector('[data-fac-addon-pins]'))[String(card.dataset.variantId)] || photo;
      const mainVariant = getMainVariant();
      const charmPin = mainVariant ? (mainPins[String(mainVariant.id)] || '') : '';
      composer.dataset.pinBase = basePin || '';
      composer.dataset.pinCharm = charmPin || '';
      if (!canvas || !basePin || !charmPin || !window.FaccoPin) {
        showFallback();
        return;
      }
      window.FaccoPin.compose(canvas, basePin, [charmPin], { scale: 34, gap: 13 }).then((ok) => {
        if (ok === false) return;
        if (fallback) fallback.hidden = true;
        canvas.hidden = false;
        preview.hidden = false;
      }).catch(showFallback);
    };

    const updateStatus = () => {
      cards.forEach(syncCard);
      const selected = selectedCards();
      if (summary) summary.hidden = selected.length === 0;

      if (mode === 'charm') renderPreview(selected[0] || null);

      if (count) {
        if (mode === 'charm') {
          count.textContent = selected[0] ? faccoText('baseSelected', 'Base selezionata: {{ title }}', { title: readAddon(selected[0]).title || '' }) : '';
        } else {
          count.textContent = selected.length === 1 ? faccoText('oneCharmSelected', '1 charm selezionato') : faccoText('manyCharmsSelected', '{{ count }} charm selezionati', { count: selected.length });
        }
      }

      drawers.forEach((drawer) => {
        const selectedInDrawer = Array.from(drawer.querySelectorAll('[data-fac-addon].is-selected'));
        const status = composer.querySelector(`[data-fac-drawer-status="${drawer.id}"]`);
        const trigger = composer.querySelector(`[data-fac-drawer-open="${drawer.id}"]`);
        if (!status || !trigger) return;

        if (selectedInDrawer.length === 0) {
          status.textContent = '';
          trigger.classList.remove('has-selection');
        } else {
          const firstTitle = readAddon(selectedInDrawer[0]).title || '';
          status.textContent = selectedInDrawer.length === 1 ? firstTitle : faccoText('selectedMany', '{{ count }} selezionati', { count: selectedInDrawer.length });
          trigger.classList.add('has-selection');
        }
      });
    };

    const closeDrawer = (drawer, restoreFocus = true) => {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      composer.querySelector(`[data-fac-drawer-open="${drawer.id}"]`)?.setAttribute('aria-expanded', 'false');

      window.setTimeout(() => {
        drawer.hidden = true;
        if (!document.querySelector('.fac-addon-drawer-v24.is-open')) {
          document.documentElement.classList.remove('fac-addon-drawer-open');
          document.body.classList.remove('fac-addon-drawer-open');
        }
        if (restoreFocus && lastOpener?.isConnected) lastOpener.focus();
      }, 230);
    };

    const openDrawer = (drawer, trigger) => {
      if (!drawer) return;
      document.querySelectorAll('.fac-addon-drawer-v24.is-open').forEach((open) => closeDrawer(open, false));
      lastOpener = trigger;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      trigger?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('fac-addon-drawer-open');
      document.body.classList.add('fac-addon-drawer-open');
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        drawer.querySelector('.fac-addon-drawer-v24__panel')?.focus();
      });
    };

    composer.querySelectorAll('[data-fac-drawer-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const drawer = document.getElementById(trigger.dataset.facDrawerOpen);
        openDrawer(drawer, trigger);
      });
    });

    drawers.forEach((drawer) => {
      drawer.querySelectorAll('[data-fac-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(drawer));
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer(drawer);
        }
      });

      // Portal: il pannello viene portato direttamente nel body, fuori da ogni
      // contenitore della scheda prodotto che potrebbe tagliarlo o spostarlo.
      document.body.appendChild(drawer);
    });

    cards.forEach((card) => {
      card.querySelector('[data-fac-addon-variant]')?.addEventListener('change', () => {
        syncCard(card);
        updateStatus();
      });

      card.querySelector('[data-fac-addon-toggle]')?.addEventListener('click', () => {
        if (card.classList.contains('is-incompatible')) return;

        if (mode === 'charm' && !card.classList.contains('is-selected')) {
          cards.forEach((other) => {
            if (other === card) return;
            other.classList.remove('is-selected');
            const otherButton = other.querySelector('[data-fac-addon-toggle]');
            otherButton?.setAttribute('aria-pressed', 'false');
            if (otherButton) otherButton.textContent = faccoText('add', 'AGGIUNGI');
          });
        }

        card.classList.toggle('is-selected');
        const isSelected = card.classList.contains('is-selected');
        const button = card.querySelector('[data-fac-addon-toggle]');
        button?.setAttribute('aria-pressed', String(isSelected));
        if (button) button.textContent = isSelected ? faccoText('remove', 'RIMUOVI') : faccoText('add', 'AGGIUNGI');
        updateStatus();

        if (mode === 'charm' && isSelected) {
          window.setTimeout(() => closeDrawer(card.closest('[data-fac-composer-drawer]')), 140);
        }
      });
    });

    const form = composer.closest('.product-details')?.querySelector('product-form-component form[action*="/cart/add"]')
      || document.querySelector('product-form-component form[action*="/cart/add"]');

    if (form && form.dataset.facComposerV24Ready !== 'true') {
      form.dataset.facComposerV24Ready = 'true';
      // In ascolto sulla finestra (prima del gestore del tema sul documento):
      // cosi il tema non aggiunge il gioiello una seconda volta.
      window.addEventListener('submit', async (event) => {
        if (event.target !== form) return;
        const selected = selectedCards();
        if (selected.length === 0) return;

        const mainVariant = getMainVariant();
        if (!mainVariant) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        try {
          const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
          // Charm + base: nel carrello e nell'email diventano un unico Gioiello con la foto composta (v124).
          const mainTitle = readMainProduct()?.title || '';
          const baseTitle = readAddon(selected[0]).title || '';
          const visible = { 'Il tuo Gioiello': [baseTitle, mainTitle].filter(Boolean).join(' + ') };
          const addons = selected.map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }));
          const main = { id: Number(mainVariant.id), quantity };
          let items;
          let compose = null;
          let fallback = {};
          if (mode === 'charm') {
            // la base per prima, poi il charm della pagina
            items = [...addons, main];
            if (composer.dataset.pinBase && composer.dataset.pinCharm) {
              compose = { base: composer.dataset.pinBase, charms: [composer.dataset.pinCharm], opt: { scale: 34, gap: 13 } };
            }
            fallback = { _pin_base: composer.dataset.pinBase || '', _pin_charms: composer.dataset.pinCharm || '' };
          } else {
            // pagina della base: la base per prima, poi i Simboli scelti
            items = [main, ...addons];
            const product = readMainProduct();
            const basePhoto = mainVariant.featured_image?.src || product?.featured_image || '';
            const charmPhotos = selected.map((card) => {
              const data = readAddon(card);
              const v = (data.variants || []).find((x) => String(x.id) === String(card.dataset.variantId));
              return readPins(card.querySelector('[data-fac-addon-pins]'))[String(card.dataset.variantId)] || v?.featured_image?.src || data.featured_image || '';
            }).filter(Boolean);
            if (basePhoto && charmPhotos.length) compose = { base: basePhoto, charms: charmPhotos, opt: { scale: 34, gap: 13 } };
            fallback = { _pin_base: basePhoto, _pin_charms: charmPhotos.join('|') };
          }
          const root = window.Shopify?.routes?.root || '/';

          if (window.FaccoPinCart) {
            await window.FaccoPinCart.add({ items, name: composer.dataset.pinName || 'Il tuo Gioiello', props: visible, compose, fallback });
          } else {
            const props = Object.assign({}, visible, { _pin_id: String(Date.now()) }, fallback);
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items.map((it) => ({ ...it, properties: props })) })
            });
            if (!response.ok) throw new Error('Cart error');
          }
          window.location.href = `${root}cart`;
        } catch (_) {
          if (submitButton) submitButton.disabled = false;
        }
      }, true);
    }

    document.addEventListener('facco:variant-change', updateStatus);
    updateStatus();
  };

  const initAll = (root = document) => {
    root.querySelectorAll?.('[data-fac-composer-v24]').forEach(initComposer);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
